module.exports = __webpack_public_path__ + "img/专利证书05_分布式能源系统智能优化设计软件v1.0.a69e0e3d.png";